export const getMoncaoMelgacoData = () => ({
  name: "Monção e Melgaço",
  country: "Portugal",
  region: "Vinho Verde",
  description: "Monção e Melgaço est la sous-région la plus prestigieuse du Vinho Verde, produisant des vins blancs secs et aromatiques avec le cépage Alvarinho.",
  type: "subregion",
  mapAreas: [
    { region: "Monção e Melgaço", x: 44, y: 28, color: "#4B164C", size: 4 }
  ],
  statistics: {
    totalArea: "2,000 ha",
    production: "100,000 hl",
    wineries: "50+ quintas",
    villages: "8 villages",
    exportPercentage: "70%"
  },
  characteristics: {
    climate: "Climat océanique tempéré, étés doux, hivers doux",
    soil: "Sols granitiques, argilo-calcaires",
    viticulture: "Viticulture traditionnelle, rendements contrôlés"
  },
  wineStyles: {
    white: "Blancs secs et aromatiques, acidité vive, notes d'agrumes et de fleurs"
  },
  history: "Monção e Melgaço produit des vins depuis l'époque romaine. La région est célèbre pour ses vins blancs de qualité.",
  foodPairing: "Fruits de mer, poissons, cuisine portugaise, fromages frais",
  grapeVarieties: [
    {
      name: "Alvarinho",
      percentage: "90%",
      description: "Cépage roi de Monção e Melgaço, produisant des vins secs et aromatiques",
      characteristics: "Sec, aromatique, acidité vive, notes d'agrumes et de fleurs",
      wineStyles: "Sec, léger, aromatique"
    },
    {
      name: "Loureiro",
      percentage: "8%",
      description: "Cépage d'assemblage, apportant élégance et fraîcheur",
      characteristics: "Élégant, fraîcheur, notes florales, structure légère",
      wineStyles: "Sec, léger, floral"
    },
    {
      name: "Trajadura",
      percentage: "2%",
      description: "Cépage d'assemblage, apportant rondeur",
      characteristics: "Rond, doux, notes de fruits blancs",
      wineStyles: "Sec, léger, fruité"
    }
  ]
}); 